/* eslint-disable react/no-danger */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable no-nested-ternary */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { injectIntl, FormattedMessage } from 'react-intl';
import Avatar from 'assets/icons/avatar.png';
import './BotResponse.scss';
import Arrow from 'assets/icons/blue-bubble-arrow.svg';
import ReactSVG from 'react-svg';
import { updateSummary } from 'shared/redux/actions';
import { connect } from 'react-redux';
import classNames from 'classnames';
import iconArrowNext from 'assets/icons/iconArrowNext.png';
import { Modal } from 'components';
// import numeral from 'numeral';
import MarkazOfficeMap from 'assets/images/markazOffice.jpg';

class BotResponse extends Component {
  static propTypes = {
    /** Message to display */
    message: PropTypes.string,
    /** to translate string or not */
    toTranslate: PropTypes.bool,
    /** to translate options based on string */
    toOptionTranslate: PropTypes.string,
    /** is End of conversation */
    isFinish: PropTypes.bool,
    /** Is RTL */
    rtl: PropTypes.bool,
  };

  static defaultProps = {
    message: 'message from bot',
    toTranslate: true,
    isFinish: false,
    toOptionTranslate: '',
    rtl: false,
  };

  state = {
    modalVisible: false,
  };

  componentDidMount() {
    // to update risk profile after answers all questions
    const { options, onUpdateSummary } = this.props;
    if (options && options.risk) onUpdateSummary({ 'summary.risk': options.risk });
  }

  render() {
    const {
      message, intl, options, toTranslate, isFinish, toOptionTranslate, rtl, cta, CMAClassification,
    } = this.props;
    // const intlMessage = intl.formatMessage({ id: `${message}` }, options);
    let intlMessage;

    if (options && options.toTranslate === false) {
      intlMessage = message;
    } else if (toOptionTranslate === 'summary_appointment') {
      intlMessage = intl.formatMessage({ id: `${message}` }, {
        date: options.date,
        time: options.time,
        place: options.place === 'askClosestBankBranch.convo.quick_replies.1' ? intl.formatMessage({ id: options.place }) : options.place === 'askClosestBankBranch.convo.quick_replies.2' ? intl.formatMessage({ id: options.place }) : options.place,
      });
    } else if (options && options.richText) {
      let translateOptions = { text: options.text && intl.formatMessage({ id: options.text }) };
      if (message === 'askTargetAmount.convo.ask.1' || message === 'targetAmountIsInvalid') {
        translateOptions = {
          text: intl.formatMessage({ id: options.text }),
          name: options.name,
          amount: options.amount,
          // amount: options.amounts && numeral(options.amounts[options.text]).format(0, 0),
        };
      } else if (message === 'askQualifiedInvestor.convo.ask.1') {
        translateOptions = { CMAClassification: options.CMAClassification && intl.formatMessage({ id: CMAClassification }) };
      }
      intlMessage = (
        <div
          dangerouslySetInnerHTML={{ __html: intl.formatMessage({ id: `${message}` }, options.toTranslate ? translateOptions : options) }}
        />
      );
    } else if (options && options.toTranslate) {
      intlMessage = intl.formatMessage({ id: `${message}` }, { text: intl.formatMessage({ id: options.text }) });
    } else {
      intlMessage = intl.formatMessage({ id: `${message}` }, options);
    }

    const classes = classNames({
      'bot-response': true,
      'bot-response--finish': isFinish,
      'bot-response--rtl': rtl,
      'bot-response--with-cta': cta,
    });

    return (
      <div className={classes}>

        <img src={Avatar} alt="NW Bot avatar" className="avatar avatar--medium" />

        <div className={`bot-response__message ${(options && options.isLocation) ? 'bot-response__message--maps' : ''}`}>
          {(options && options.isLocation)
            ? (
              <div className="bot-response__message__maps" style={{ backgroundImage: `url(${MarkazOfficeMap})` }} />
            ) : <></>}
          <div className={(options && options.isLocation) ? 'bot-response__message__text' : ''}>
            {toTranslate ? intlMessage : message}
          </div>
          <ReactSVG src={Arrow} className="arrow" />
          {cta
            && (
            <div className="bot-response__cta" onClick={() => this.setState({ modalVisible: true })}>
              <FormattedMessage id="investmentPreference.knowMore" />
              <img src={iconArrowNext} alt={Arrow} />
            </div>
            )
          }
        </div>

        {cta
        && (
        <Modal
          customizedClassName="modal--fullscreen"
          title={intl.formatMessage({ id: 'investment_type.title' })}
          isPopupShowing={this.state.modalVisible}
          closePopup={() => this.setState({ modalVisible: false })}
        >
          <div className="modal__body modal__body--column">
            <p dangerouslySetInnerHTML={{ __html: intl.formatMessage({ id: 'qualifiedClientDefinition' }) }} />
            <p dangerouslySetInnerHTML={{ __html: intl.formatMessage({ id: 'retailClientDefinition' }) }} />
          </div>
        </Modal>
        )}

      </div>
    );
  }
}

const mapStateToProps = state => ({
  CMAClassification: state.rootReducer.CMAClassification,
});
const mapDispatchToProps = dispatch => ({
  onUpdateSummary: reply => dispatch(updateSummary(reply)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(injectIntl(BotResponse));
